import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { transformInfoValues } from './utils.js';
export default function TooltipContent(props) {
    const { info, featureType, featureLabelsMap, } = props;
    const mappedInfo = useMemo(() => {
        if (!featureType || !featureLabelsMap) {
            return info;
        }
        return transformInfoValues(info, featureType, featureLabelsMap);
    }, [info, featureType, featureLabelsMap]);
    return (_jsx("table", { children: _jsx("tbody", { children: Object.entries(mappedInfo).map(([key, value]) => (_jsxs("tr", { children: [_jsx("th", { children: key }), _jsx("td", { children: value })] }, key))) }) }));
}
//# sourceMappingURL=TooltipContent.js.map